import React, { useEffect } from "react";

import { calculatePrice, getCurrencySymbol } from "../../utilities/utilities";
import { addItem } from "../cart/cartSlice";
import { loadData } from "./inventorySlice";

import { inventoryData } from "../../utilities/data";

export const Inventory = ({ inventory, currencyFilter, dispatch }) => {
  const onMount = () => {
    console.log("loaded inventory");
    dispatch(loadData(inventoryData));
  };
  useEffect(onMount, [dispatch]);

  const onClickHandler = (inventoryItem) => {
    dispatch(addItem(inventoryItem));
  };

  if (inventory.length === 0) {
    return <p> Sorry, no products are available... </p>;
  }

  return <ul id="inventory-container">{inventory.map(createInventoryItem)}</ul>;

  function createInventoryItem(inventoryItem) {
    const { price, name, img } = inventoryItem;
    const displayPrice = calculatePrice(price, currencyFilter);
    return (
      <li key={name} className="item">
        <img src={img} alt={""} />
        <h3>{name}</h3>
        <h3 className="price">
          {getCurrencySymbol(currencyFilter)}
          {displayPrice.toFixed(2)} {currencyFilter}
        </h3>
        <button
          onClick={() => onClickHandler(inventoryItem)}
          className="add-to-cart-button"
        >
          Add to Cart
        </button>
      </li>
    );
  }
};
